/* eslint-disable import/no-named-as-default */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import CreateOrder from './CreateOrder';
import CheckServiceAvailability from './CheckServiceAvailability';
import PortInOrderDetail from './PortInOrderDetail';
import NumberActivated from './NumberActivated';
import Page404 from '../../../components/Page404/Page404';
import NotAssessable from './NotAssessable';
import Home from './Home';

const PrivateRoute = (...params) => {
  const isPortingAccessable = useSelector(state => state.UIState.inteliquent.access);
  const userHasPortAccess = useSelector(state => state.AppState.user.portingAccessEnabled);
  return isPortingAccessable || userHasPortAccess ? <Route {...params[0]} /> : <NotAssessable />;
};

export default function PortingRouting() {
  return (
    <Switch className="mt-10">
      <PrivateRoute exact component={Home} path="/provisioning/porting" />
      <PrivateRoute exact component={CreateOrder} path="/provisioning/porting/create-order/:id?" />
      <PrivateRoute
        exact
        component={CheckServiceAvailability}
        path="/provisioning/porting/check-service-availability"
      />
      <PrivateRoute exact component={PortInOrderDetail} path="/provisioning/porting/order/:id" />
      <PrivateRoute
        exact
        component={NumberActivated}
        path="/provisioning/porting/order/:id/activate"
      />
      <Route component={Page404} />
    </Switch>
  );
}
